import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from './Form';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';
import { updateThanksReceivedFrom as updateThanksReceivedFromGoal } from '../../goals/memos/duck';
import { updateThanksReceivedFrom as updateThanksReceivedFromProject } from '../duck';

class SendThanks extends React.Component {
  handleSubmit = ({ content }, dispatch, { memo }) => {
    const {
      updateThanksReceivedFromProject,
      updateThanksReceivedFromGoal,
      onSuccess,
      type,
    } = this.props;

    return (
      API.put(`memos/${memo._id}/send-thanks`)
        // Delay with 1 second, to prevent flashing of the loading message for too short
        .then(
          (res) =>
            new Promise((resolve) => setTimeout(() => resolve(res), 1000))
        )
        // Refresh the memos thanks
        .then(({ thanksReceivedFrom }) => {
          return type === 'PROJECT'
            ? updateThanksReceivedFromProject(memo._id, thanksReceivedFrom)
            : updateThanksReceivedFromGoal(memo._id, thanksReceivedFrom);
        })
        .then(onSuccess)
        .catch(catchFormErrors)
    );
  };

  render() {
    const {
      memo,
      isCurrentlyLoggedInUserMemo,
      currentUserId,
      type,
    } = this.props;

    return (
      <Form
        form={`send-thanks-${memo._id}`}
        initialValues={{}}
        memo={memo}
        isCurrentlyLoggedInUserMemo={isCurrentlyLoggedInUserMemo}
        currentUserId={currentUserId}
        onSubmit={this.handleSubmit}
        type={type}
      />
    );
  }
}

SendThanks.defaultProps = {
  type: 'PROJECT',
};

SendThanks.propTypes = {
  type: PropTypes.oneOf(['PROJECT', 'GOAL']),
};

const mapDispatchToProps = {
  updateThanksReceivedFromGoal,
  updateThanksReceivedFromProject,
};

export default connect(
  null,
  mapDispatchToProps
)(translate()(SendThanks));



// WEBPACK FOOTER //
// ./src/memos/send-thanks/index.js